var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 1C2.9065 1 1 2.9065 1 5.25C1 6.259 1.36225 7.23825 2.02325 8.012C2.09875 8.09775 3.88 10.1217 4.475 10.689C4.69225 10.8962 4.971 11 5.25 11C5.529 11 5.80775 10.8962 6.02525 10.689C6.717 10.0293 8.40625 8.09275 8.48025 8.00775C9.13775 7.23825 9.5 6.259 9.5 5.25C9.5 2.9065 7.5935 1 5.25 1ZM5.25 6.5C4.55975 6.5 4 5.94025 4 5.25C4 4.55975 4.55975 4 5.25 4C5.94025 4 6.5 4.55975 6.5 5.25C6.5 5.94025 5.94025 6.5 5.25 6.5Z",
    fill: "white",
    stroke: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.81f90676f618017d1712fb0f0d80809b.svg";
export { ForwardRef as ReactComponent };